import { render, staticRenderFns } from "./NotificationNavbar.vue?vue&type=template&id=49e2cf7f&scoped=true"
import script from "./NotificationNavbar.vue?vue&type=script&lang=js"
export * from "./NotificationNavbar.vue?vue&type=script&lang=js"
import style0 from "./NotificationNavbar.vue?vue&type=style&index=0&id=49e2cf7f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49e2cf7f",
  null
  
)

export default component.exports